import * as React from 'react'
import { BLUE } from '@omnilert/components'

/**
 * Renders a map location marker/pin SVG icon with a drop shadow
 * @param {object} props - Component props
 * @returns {JSX.Element} Marker icon SVG element
 */
function Marker(props) {
  return (
    <svg
      fill='none'
      height={56}
      viewBox='0 0 48 56'
      width={48}
    >
      <g
        filter='url(#prefix__filter0_ddi)'
        stroke={BLUE}
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path
          d='M24 12.71a7.5 7.5 0 017.5 7.5c0 3.547-5.5 12.381-7.079 14.85a.5.5 0 01-.842 0C22 32.592 16.5 23.757 16.5 20.21a7.5 7.5 0 017.5-7.5v0z'
          strokeWidth={2}
        />
        <path d='M24 23.21a3 3 0 100-6 3 3 0 000 6z' />
      </g>
      <defs>
        <filter
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
          height={56}
          id='prefix__filter0_ddi'
          width={48}
          x={0}
          y={0}
        >
          <feFlood
            floodOpacity={0}
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={7.5} />
          <feColorMatrix values='0 0 0 0 0.116667 0 0 0 0 0.682 0 0 0 0 1 0 0 0 0.25 0' />
          <feBlend
            in2='BackgroundImageFix'
            result='effect1_dropShadow'
          />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0' />
          <feBlend
            in2='effect1_dropShadow'
            result='effect2_dropShadow'
          />
          <feBlend
            in='SourceGraphic'
            in2='effect2_dropShadow'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            result='hardAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={-2} />
          <feComposite
            in2='hardAlpha'
            k2={-1}
            k3={1}
            operator='arithmetic'
          />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.23 0' />
          <feBlend
            in2='shape'
            result='effect3_innerShadow'
          />
        </filter>
      </defs>
    </svg>
  )
}

export default Marker
